/* tslint:disable */
import { ProdcharColor } from './prodchar-color';

/**
 */
export class ProductElmt {
    SHAPE_POS1?: number;
    ID_PRODUCT_ELMT?: number;
    ID_SHAPE?: number;
    ID_COMP?: number;
    PROD_ELMT_NAME?: string;
    SHAPE_PARAM1?: number;
    SHAPE_PARAM2?: number;
    SHAPE_PARAM3?: number;
    SHAPE_PARAM4?: number;
    SHAPE_PARAM5?: number;
    PROD_DEHYD?: number;
    PROD_DEHYD_COST?: number;
    ID_PROD?: number;
    SHAPE_POS2?: number;
    SHAPE_POS3?: number;
    PROD_ELMT_ISO?: number;
    ORIGINAL_THICK?: number;
    NODE_DECIM?: number;
    INSERT_LINE_ORDER?: number;
    PROD_ELMT_WEIGHT?: number;
    PROD_ELMT_REALWEIGHT?: number;
    ID_STUDY?: number;
    SHAPECODE?: number;
    componentName?: string;
    prodcharColor?: ProdcharColor;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/product-elmt.ts